import { client } from '@global/Api';
import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  GET_DELIVERY_OPTIONS_RESPONSE,
  GET_DELIVERY_OPTIONS,
  GET_DELIVERY_OPTIONS_VARIABLES,
} from '@global/requests/checkout';
import { DeliveryOption } from '@global/types/types';

export const getDeliveryOptions = createAsyncThunk<
  DeliveryOption[],
  { uid: string; country?: string },
  { rejectValue: string }
>('cart/getDeliveryOptions', async ({ uid, country }, { rejectWithValue }) => {
  try {
    const result = await client.query<
      GET_DELIVERY_OPTIONS_RESPONSE,
      GET_DELIVERY_OPTIONS_VARIABLES
    >({
      query: GET_DELIVERY_OPTIONS,
      variables: { uid, country: country?.toUpperCase() },
    });

    return result.data.wGetCheckoutDeliveryOptions?.deliveryOptions;
  } catch (error) {
    console.error(error);
    return rejectWithValue('SERVER ERROR');
  }
});
